export default __webpack_public_path__ + "static/media/info_blue.3c371c8e.svg";